import './HelpMobile.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Icon } from 'semantic-ui-react';
import { partial } from 'lodash';

import HelpNavMobile from 'components/help/nav/HelpNavMobile';
import HelpTopic from 'components/help/HelpTopic';

class HelpMobile extends React.Component {
  static propTypes = {
    helpState: PropTypes.object.isRequired,
    selectedNodeId: PropTypes.string,
  };

  static contextTypes = {
    getString: PropTypes.func.isRequired,
  };

  static pages = {
    topic: 'TOPIC_PAGE',
    nav: 'NAV_PAGE',
  };

  constructor(props) {
    super(props);

    this.state = {
      page: HelpMobile.pages.topic,
    };

    this.updatePage = this.updatePage.bind(this);
  }

  updatePage(page) {
    this.setState({
      page,
    });
  }

  renderTopicPage() {
    const { getString } = this.context;
    return (
      <div>
        <h1 id="aa-help-mobile-root-topic-title">
          { this.props.helpState.currentNode.rootAncestorTitle }
        </h1>
        <Grid centered>
          <Grid.Row>
            <Grid.Column width={13}>
              <div
                className="btn btn-default btn-block aa-help-mobile-topics-btn"
                onClick={partial(this.updatePage, HelpMobile.pages.nav)}
              >
                { getString('AA_Help_Navigation_Title') }
                <Icon className="aa-help-mobile-topics-btn__icon" name="chevron right" />
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={15}>
              <HelpTopic helpNode={this.props.helpState.currentNode} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }

  renderNavPage() {
    return (
      <div>
        <HelpNavMobile
          nodeHierarchy={this.props.helpState.nodeHierarchy}
          selectedNodeId={this.props.selectedNodeId}
          backHandler={partial(this.updatePage, HelpMobile.pages.topic)}
        />
      </div>
    );
  }

  render() {
    const currentPage = this.state.page;
    const { pages } = HelpMobile;

    switch (currentPage) {
      case pages.topic:
        return this.renderTopicPage();
      case pages.nav:
        return this.renderNavPage();
      default:
        return null;
    }
  }
}

export default HelpMobile;
